import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore, useAuth } from '@sib/auth';

export interface ProtectedRouteProps {
  fallbackPath: string;
}

export const ProtectedRoute = ({
  fallbackPath,
  children,
}: PropsWithChildren<ProtectedRouteProps>) => {
  useAuth();
  const { isAuthenticated } = useAuthStore();

  return isAuthenticated ? <>{children}</> : <Navigate to={fallbackPath} />;
};
